import axios from "axios";
import { IAxiosReturn } from "../interface";
import { processAxiosError } from "../processAxiosError";

export type IReportTypesReturn = IAxiosReturn<string[]>;

/**
 * Retrieves the list of available report types from the API.
 *
 * @param backEndUrl - The backend API base URL
 * @param _ - The unused parameter for data
 * @param controller - AbortController for request cancellation
 * @returns Promise resolving to report types array or error information
 */
export const getReportTypes = async (
  backEndUrl: string,
  _: null,
  controller: AbortController,
): Promise<IReportTypesReturn> => {
  try {
    const response = await axios.get<string[]>(`${backEndUrl}Hierarchy/ReportTypes`, {
      signal: controller.signal,
    });
    return { success: true, data: response.data };
  } catch (error: unknown) {
    return processAxiosError("Failed to retrieve report types", error);
  }
};
